import produce from 'immer';

export const Types = {
  POST_WEBHOOK_EVENT_HEADER_REQUEST:
    '@webhookEventHeaderIntegration/POST_WEBHOOK_EVENT_HEADER_REQUEST',
  POST_WEBHOOK_EVENT_HEADER_RESPONSE:
    '@webhookEventHeaderIntegration/POST_WEBHOOK_EVENT_HEADER_RESPONSE',
  PUT_WEBHOOK_EVENT_HEADER_REQUEST:
    '@webhookEventHeaderIntegration/PUT_WEBHOOK_EVENT_HEADER_REQUEST',
  PUT_WEBHOOK_EVENT_HEADER_RESPONSE:
    '@webhookEventHeaderIntegration/PUT_WEBHOOK_EVENT_HEADER_RESPONSE',
  GET_WEBHOOK_EVENT_HEADERS_LIST_REQUEST:
    '@webhookEventHeaderIntegration/GET_WEBHOOK_EVENT_HEADERS_LIST_REQUEST',
  GET_WEBHOOK_EVENT_HEADERS_LIST_RESPONSE:
    '@webhookEventHeaderIntegration/GET_WEBHOOK_EVENT_HEADERS_LIST_RESPONSE',
  DELETE_WEBHOOK_EVENT_HEADER_REQUEST:
    '@webhookEventHeaderIntegration/DELETE_WEBHOOK_EVENT_HEADER_REQUEST',
  DELETE_WEBHOOK_EVENT_HEADER_RESPONSE:
    '@webhookEventHeaderIntegration/DELETE_WEBHOOK_EVENT_HEADER_RESPONSE',
};

const INITIAL_STATE = {
  postWebhookEventHeader: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  getWebhookEventHeaderList: {
    success: false,
    error: null,
    loading: false,
    data: [],
  },
  putWebhookEventHeader: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  deleteWebhookEventHeader: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
};

export default function webhookEventHeaderIntegration(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_WEBHOOK_EVENT_HEADERS_LIST_REQUEST: {
        draft.getWebhookEventHeaderList.loading = true;
        break;
      }
      case Types.GET_WEBHOOK_EVENT_HEADERS_LIST_RESPONSE: {
        draft.getWebhookEventHeaderList.loading = false;
        draft.getWebhookEventHeaderList.data = action.payload.response;
        draft.getWebhookEventHeaderList.success = action.payload.success;
        draft.getWebhookEventHeaderList.error = false;
        break;
      }
      case Types.POST_WEBHOOK_EVENT_HEADER_REQUEST: {
        draft.postWebhookEventHeader.loading = true;
        break;
      }
      case Types.POST_WEBHOOK_EVENT_HEADER_RESPONSE: {
        draft.postWebhookEventHeader.loading = false;
        draft.postWebhookEventHeader.data = action.payload.response;
        draft.postWebhookEventHeader.success = action.payload.success;
        draft.postWebhookEventHeader.error = false;
        break;
      }

      case Types.PUT_WEBHOOK_EVENT_HEADER_REQUEST: {
        draft.putWebhookEventHeader.loading = true;
        break;
      }
      case Types.PUT_WEBHOOK_EVENT_HEADER_RESPONSE: {
        draft.putWebhookEventHeader.loading = false;
        draft.putWebhookEventHeader.data = action.payload.response;
        draft.putWebhookEventHeader.success = action.payload.success;
        draft.putWebhookEventHeader.error = false;
        break;
      }
      case Types.DELETE_WEBHOOK_EVENT_HEADER_REQUEST: {
        draft.deleteWebhookEventHeader.loading = true;
        break;
      }
      case Types.DELETE_WEBHOOK_EVENT_HEADER_RESPONSE: {
        draft.deleteWebhookEventHeader.loading = false;
        draft.deleteWebhookEventHeader.data = action.payload.response;
        draft.deleteWebhookEventHeader.success = action.payload.success;
        draft.deleteWebhookEventHeader.error = false;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  postWebhookEventHeaderRequest: (params) => ({
    type: Types.POST_WEBHOOK_EVENT_HEADER_REQUEST,
    payload: { params },
  }),
  postWebhookEventHeaderResponse: (response, success) => ({
    type: Types.POST_WEBHOOK_EVENT_HEADER_RESPONSE,
    payload: { response, success },
  }),
  getWebhookEventHeadersListRequest: (webhookEventId) => ({
    type: Types.GET_WEBHOOK_EVENT_HEADERS_LIST_REQUEST,
    payload: { webhookEventId },
  }),
  getWebhookEventHeadersListResponse: (response, success) => ({
    type: Types.GET_WEBHOOK_EVENT_HEADERS_LIST_RESPONSE,
    payload: { response, success },
  }),
  putWebhookEventHeaderRequest: (params) => ({
    type: Types.PUT_WEBHOOK_EVENT_HEADER_REQUEST,
    payload: { params },
  }),
  putWebhookEventHeaderResponse: (response, success) => ({
    type: Types.PUT_WEBHOOK_EVENT_HEADER_RESPONSE,
    payload: { response, success },
  }),
  deleteWebhookEventHeaderRequest: (idWebhookEventHeader) => ({
    type: Types.DELETE_WEBHOOK_EVENT_HEADER_REQUEST,
    payload: idWebhookEventHeader,
  }),
  deleteWebhookEventHeaderResponse: (response, success) => ({
    type: Types.DELETE_WEBHOOK_EVENT_HEADER_RESPONSE,
    payload: { response, success },
  }),
};
